export const TAG_KEYS_FOR_LIVE_DATA = {
	LATITUDE: 'IOT_DEVICE::LATITUDE::VALUE_TYPE_DOUBLE',
	BATTERY_PERCENTAGE: 'IOT_DEVICE::BATTERY_PERCENTAGE::VALUE_TYPE_DOUBLE',
	SPEED_LIMIT_STATUS_EXCEEDED:
		'IOT_DEVICE::SPEED_LIMIT_STATUS::VALUE_TYPE_BOOLEAN::EXCEEDED',
	NETWORK_STATUS_LOW_SIGNAL_STRENGTH:
		'IOT_DEVICE::NETWORK_STATUS::VALUE_TYPE_BOOLEAN::LOW_SIGNAL_STRENGTH',
	TOWING_STATUS_MACHINE_TOWING:
		'IOT_DEVICE::TOWING_STATUS::VALUE_TYPE_BOOLEAN::MACHINE_TOWING',
	EXTERNAL_POWER_CONNECTED:
		'IOT_DEVICE::EXTERNAL_POWER_CONNECTED::VALUE_TYPE_BOOLEAN',
	ACCIDENT_STATUS_HIGH_G_FORCE:
		'IOT_DEVICE::ACCIDENT_STATUS::VALUE_TYPE_BOOLEAN::HIGH_G_FORCE',
	EXTERNAL_POWER_STATUS_LOW_EXTERNAL_VOLTAGE:
		'IOT_DEVICE::EXTERNAL_POWER_STATUS::VALUE_TYPE_BOOLEAN::LOW_EXTERNAL_VOLTAGE',
	HEALTH_STATUS_DEVICE_STATUS_MALFUNCTIONED:
		'IOT_DEVICE::HEALTH_STATUS::VALUE_TYPE_BOOLEAN::DEVICE_STATUS_MALFUNCTIONED',
	LONGITUDE: 'IOT_DEVICE::LONGITUDE::VALUE_TYPE_DOUBLE',
	LOCATION_AREA: 'IOT_DEVICE::LOCATION_AREA::VALUE_TYPE_STRING',
	EXTERNAL_VOLTAGE: 'IOT_DEVICE::EXTERNAL_VOLTAGE::VALUE_TYPE_DOUBLE',
	SPEED_LIMIT_STATUS_EXCEEDED_WITH_SPRAYER_ON:
		'IOT_DEVICE::SPEED_LIMIT_STATUS::VALUE_TYPE_BOOLEAN::EXCEEDED_WITH_SPRAYER_ON',
	HEALTH_STATUS_DEVICE_STATUS_VERY_BAD:
		'IOT_DEVICE::HEALTH_STATUS::VALUE_TYPE_BOOLEAN::DEVICE_STATUS_VERY_BAD',
	IGNITION_STATUS_WIRE_TAMPERED_WITH_MOVEMENT:
		'IOT_DEVICE::IGNITION_STATUS::VALUE_TYPE_BOOLEAN::WIRE_TAMPERED_WITH_MOVEMENT',
	INTERNAL_TEMPERATURE: 'IOT_DEVICE::INTERNAL_TEMPERATURE::VALUE_TYPE_DOUBLE',
	ALTITUDE: 'IOT_DEVICE::ALTITUDE::VALUE_TYPE_INT32',
	TagProperty_TEHSIL: 'IOT_DEVICE::TagProperty_TEHSIL::VALUE_TYPE_STRING',
	ODOMETER: 'IOT_DEVICE::ODOMETER::VALUE_TYPE_DOUBLE',
	INTERNAL_BATTERY_STATUS_LOW_BATTERY:
		'IOT_DEVICE::INTERNAL_BATTERY_STATUS::VALUE_TYPE_BOOLEAN::LOW_BATTERY',
	ACCIDENT_STATUS_ROLLOVER:
		'IOT_DEVICE::ACCIDENT_STATUS::VALUE_TYPE_BOOLEAN::ROLLOVER',
	LAST_CONNECTED: 'IOT_DEVICE::LAST_CONNECTED::VALUE_TYPE_INT64',
	IGNITION_ON: 'IOT_DEVICE::IGNITION_ON::VALUE_TYPE_BOOLEAN',
	EXTERNAL_POWER_STATUS_DISCONNECTED_WITH_VIBRATION:
		'IOT_DEVICE::EXTERNAL_POWER_STATUS::VALUE_TYPE_BOOLEAN::DISCONNECTED_WITH_VIBRATION',
	TagProperty_DISTRICT: 'IOT_DEVICE::TagProperty_DISTRICT::VALUE_TYPE_STRING',
	HEALTH_STATUS_DEVICE_STATUS_ACTIVE:
		'IOT_DEVICE::HEALTH_STATUS::VALUE_TYPE_BOOLEAN::DEVICE_STATUS_ACTIVE',
	CELLULAR_SIGNAL_STRENGTH:
		'IOT_DEVICE::CELLULAR_SIGNAL_STRENGTH::VALUE_TYPE_INT32',
	HEADING_DEGREES: 'IOT_DEVICE::HEADING_DEGREES::VALUE_TYPE_INT32',
	INTERNAL_BATTERY_STATUS_INTERNAL_BATTERY_TAMPERED:
		'IOT_DEVICE::INTERNAL_BATTERY_STATUS::VALUE_TYPE_BOOLEAN::INTERNAL_BATTERY_TAMPERED',
	ENGINE_ON: 'IOT_DEVICE::ENGINE_ON::VALUE_TYPE_BOOLEAN',
	LOG_REASON: 'IOT_DEVICE::LOG_REASON::VALUE_TYPE_STRING',
	SUPPLY_GOOD: 'IOT_DEVICE::SUPPLY_GOOD::VALUE_TYPE_BOOLEAN',
	SPEED: 'IOT_DEVICE::SPEED::VALUE_TYPE_DOUBLE',
	TagProperty_STATE: 'IOT_DEVICE::TagProperty_STATE::VALUE_TYPE_STRING',
	IGNITION_STATUS_WIRE_TAMPERED:
		'IOT_DEVICE::IGNITION_STATUS::VALUE_TYPE_BOOLEAN::WIRE_TAMPERED',
	EXTERNAL_POWER_STATUS_DISCONNECTED_WITH_MOVEMENT:
		'IOT_DEVICE::EXTERNAL_POWER_STATUS::VALUE_TYPE_BOOLEAN::DISCONNECTED_WITH_MOVEMENT',
	HEALTH_STATUS_DEVICE_STATUS_BAD:
		'IOT_DEVICE::HEALTH_STATUS::VALUE_TYPE_BOOLEAN::DEVICE_STATUS_BAD',
	SPRAYER_ON: 'IOT_DEVICE::SPRAYER_ON::VALUE_TYPE_BOOLEAN',
	HEALTH_STATUS_DEVICE_STATUS_GOOD:
		'IOT_DEVICE::HEALTH_STATUS::VALUE_TYPE_BOOLEAN::DEVICE_STATUS_GOOD',
	NETWORK_STATUS_OUT_OF_NETWORK:
		'IOT_DEVICE::NETWORK_STATUS::VALUE_TYPE_BOOLEAN::OUT_OF_NETWORK',
	INTERNAL_BATTERY_VOLTAGE:
		'IOT_DEVICE::INTERNAL_BATTERY_VOLTAGE::VALUE_TYPE_DOUBLE',
	LOADED_BATTERY_VOLTAGE:
		'IOT_DEVICE::LOADED_BATTERY_VOLTAGE::VALUE_TYPE_DOUBLE',
	EXTERNAL_POWER_STATUS_EXTERNAL_POWER_REMOVED:
		'IOT_DEVICE::EXTERNAL_POWER_STATUS::VALUE_TYPE_BOOLEAN::EXTERNAL_POWER_REMOVED',
	POSITION_ACCURACY: 'IOT_DEVICE::POSITION_ACCURACY::VALUE_TYPE_INT32',
};
